import { Flex, Skeleton } from '@chakra-ui/react';
import React from 'react';

import { useFeatureFlags } from '../../../contexts/FeatureFlagProvider';
import { useCreditFacilityContext } from '~/packages/credit-facility/hooks/CreditFacilityProvider';
import { ConcentrationLimitsSection } from '~/packages/portfolio/ui/borrowingBase/ConcentrationLimitsSection';
import { PortfolioExcessConcentrationChart } from '~/packages/portfolio/ui/borrowingBase/PortfolioExcessConcentrationChart';
import {
  useConcentrationLimitsData,
  useConcentrationLimitsMetadata,
} from '~/packages/portfolio/ui/borrowingBase/useConcentrationLimitsData';
import { useCreditAgreementConcentrationLimits } from '~/packages/portfolio/ui/borrowingBase/useCreditAgreementConcentrationLimits';

export const ConcentrationContainerV2 = () => {
  const { creditFacilityId } = useCreditFacilityContext();
  const { respectConcentrationLimitFormat } = useFeatureFlags();

  // Use the custom hook for concentration limits data management
  const {
    chartDataDateRange,
    setChartDataDateRange,
    selectedTimePeriod,
    concentrationLimitChartData,
    concentrationLimitFormatMap,
    concentrationData,
    isConcentrationDataLoading,
    refetchConcentrationInsightsData,
    onSelectTimePeriod,
  } = useConcentrationLimitsData(creditFacilityId);

  // Use custom hook for credit agreement concentration limits
  const {
    creditAgreementData,
    isCreditAgreementLoading,
    creditAgreementConcentrationLimits,
  } = useCreditAgreementConcentrationLimits(creditFacilityId);

  // Use the second hook to get the limitKeyToTitleMap and combinedCsvData
  const {
    limitKeyToTitleMap,
    combinedCsvData,
  } = useConcentrationLimitsMetadata(
    concentrationLimitFormatMap,
    creditAgreementConcentrationLimits,
    concentrationLimitChartData,
  );

  if (
    !concentrationData ||
    isConcentrationDataLoading ||
    !creditAgreementData ||
    isCreditAgreementLoading
  ) {
    return <Skeleton data-testid="loading-insights-view" height="600px" />;
  }

  return (
    <Flex direction="column" gap="2.5rem">
      <PortfolioExcessConcentrationChart
        creditFacilityId={creditFacilityId}
        chartTitle="Excess Concentration Amounts"
        concentrationLimitFormatMap={concentrationLimitFormatMap}
        creditAgreementConcentrationLimits={creditAgreementConcentrationLimits}
      />
      <ConcentrationLimitsSection
        creditFacilityId={creditFacilityId}
        chartDataDateRange={chartDataDateRange}
        setChartDataDateRange={setChartDataDateRange}
        selectedTimePeriod={selectedTimePeriod}
        onSelectTimePeriod={onSelectTimePeriod}
        refetchConcentrationInsightsData={refetchConcentrationInsightsData}
        concentrationLimitFormatMap={concentrationLimitFormatMap}
        concentrationLimitChartData={concentrationLimitChartData}
        creditAgreementConcentrationLimits={creditAgreementConcentrationLimits}
        limitKeyToTitleMap={limitKeyToTitleMap}
        combinedCsvData={combinedCsvData}
        respectConcentrationLimitFormat={respectConcentrationLimitFormat}
      />
    </Flex>
  );
};
